import { gql } from "@apollo/client";

export const RegisterSubscriber = gql`
    mutation RegisterSubscriber {
        registerSubscriber {
            id
            applicationId
            hmacHash
        }
    }
`;
